import { FC, JSX, useEffect, useState } from "react";

import { EventBusTopic } from "@moodys/mdc-frontend.utils.event-bus";

import { LetterformSpinner } from "@moodys/federated";
import { useEventBus } from "hooks/useEventBus";
import { useUserInfo } from "hooks/useUserInfo/useUserInfo";

interface SecureRouteProps {
  page: JSX.Element;
}

export const SecureRoute: FC<SecureRouteProps> = ({ page }) => {
  const [, setSignInModalOpen] = useEventBus(EventBusTopic.SignInModalOpen);
  const { isAuthenticated, userEmail } = useUserInfo();
  const [shouldRenderPage, setShouldRenderPage] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);

  useEffect(() => {
    if (isAuthenticated === false) {
      setIsPageLoading(false);
      setSignInModalOpen({ redirectOnClose: true });
    } else if (isAuthenticated && userEmail) {
      setShouldRenderPage(true);
      setIsPageLoading(false);
    }
  }, [isAuthenticated, userEmail]);

  if (isPageLoading) {
    return <LetterformSpinner />;
  }

  if (shouldRenderPage) {
    return page;
  }

  return null;
};
